import { CompanySettings } from '../../common/interfaces/companySettings';
import { SessionStore } from '../../constants';
import { TaskItem } from '../../taskList/interfaces';
import { TaskItemStatus } from '../../taskList/constants';

export const checkFormsCompleted = (items: TaskItem[]): TaskItem[] => {
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  return items.map((item) => {
    if (item.completionIndicator && formStatus && formStatus[item.completionIndicator])
      item.status = TaskItemStatus.COMPLETED;
    return { ...item };
  });
};

export const formsIndicators = (): {
  [index: string]: boolean | undefined;
} => {
  let companySettings: CompanySettings | null = null;
  const companySettingsString = sessionStorage.getItem(SessionStore.companySettings);

  if (companySettingsString) {
    companySettings = JSON.parse(companySettingsString);
  }

  const indicatorObj: { [index: string]: boolean | undefined } = {
    appFormIndicator: companySettings?.showAppform,
    eeoIndicator: companySettings?.showEeo,
    yourResponsibilityIndicator: companySettings?.showYourResponsiblity,
    ofccpIndicator: companySettings?.enableOfccp,
    researchQuestionsIndicator: companySettings?.allowCEBDemographyResearch,
  };

  return indicatorObj;
};
